/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetAccessProfileQueryResponse, GetAccessProfileQueryParams, GetAccessProfile400, GetAccessProfile401, GetAccessProfile403, GetAccessProfile404, GetAccessProfile409, GetAccessProfile500 } from "../../types/authorizationController/GetAccessProfile.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetAccessProfileUrl() {
  const res = { method: 'GET', url: `/api/auth/profile/access` as const }
  return res
}

/**
 * @summary Get user access profile
 * {@link /api/auth/profile/access}
 */
export async function getAccessProfile(params: GetAccessProfileQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetAccessProfileQueryResponse, ResponseErrorConfig<GetAccessProfile400 | GetAccessProfile401 | GetAccessProfile403 | GetAccessProfile404 | GetAccessProfile409 | GetAccessProfile500>, unknown>({ method : "GET", url : getGetAccessProfileUrl().url.toString(), params, ... requestConfig })
  return res.data
}